if (!customElements.get('comparison-table')) {
  class ComparisonTable extends HTMLElement {
    connectedCallback() {
      this.inCartText  = this.dataset.inCartText  || 'In Cart';
      this.atcText     = this.dataset.atcText     || 'Add to cart';
      this.soldOutText = this.dataset.soldOutText || 'Sold out';

      this._onSubmitBound = this._onSubmit.bind(this);
      this.addEventListener('submit', this._onSubmitBound);
      this._bindCartListeners();
    }

    disconnectedCallback() {
      if (this._onSubmitBound) this.removeEventListener('submit', this._onSubmitBound);
      if (this._syncBound) {
        ['cart:updated', 'theme:cart:updated', 'ajaxCart:afterCartLoad', 'cart:refresh'].forEach(ev => {
          document.removeEventListener(ev, this._syncBound);
        });
      }
    }

    _bindCartListeners() {
      this._syncBound = this._syncCartState.bind(this);
      ['cart:updated', 'theme:cart:updated', 'ajaxCart:afterCartLoad', 'cart:refresh'].forEach(ev => {
        document.addEventListener(ev, this._syncBound);
      });
      this._patchFetch();
    }

    _patchFetch() {
      if (window._ctFetchPatched) return;
      window._ctFetchPatched = true;
      const _fetch = window.fetch;
      window.fetch = (...args) => {
        const url = (typeof args[0] === 'string' ? args[0] : args[0]?.url) || '';
        const p = _fetch.apply(window, args);
        if (/\/cart\/(change|remove|update|clear)/.test(url)) {
          p.then(() => document.querySelectorAll('comparison-table').forEach(el => el._syncCartState()));
        }
        return p;
      };
    }

    _onSubmit(e) {
      const form = e.target;
      if (!form.classList.contains('comparison-table__atc-form')) return;
      e.preventDefault();

      const btn  = form.querySelector('button[type="submit"]');
      const wrap = form.closest('.comparison-table__atc-wrap');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(r => { if (!r.ok) throw new Error('add_failed'); return r.json(); })
        .then(() => {
          this._setInCart(wrap);
          return this._refreshCartUI();
        })
        .catch(err => { console.error('[comparison-table] add to cart failed:', err); });
    }

    _syncCartState() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .then(cart => {
          const cartProductIds = new Set(cart.items.map(i => i.product_id));

          this.querySelectorAll('.comparison-table__atc-wrap').forEach(wrap => {
            const productId = parseInt(wrap.dataset.productId, 10);
            if (!productId) return;

            const inCartNow     = cartProductIds.has(productId);
            const showingInCart = !!wrap.querySelector('.comparison-table__atc-btn--in-cart');

            if (inCartNow && !showingInCart) {
              this._setInCart(wrap);
            } else if (!inCartNow && showingInCart) {
              wrap.dataset.available === 'true' ? this._setATC(wrap) : this._setSoldOut(wrap);
            }
          });

          this._updateCartCount(cart.item_count);
        });
    }

    _setInCart(wrap) {
      const tmpl = this.querySelector('template[data-tmpl="in-cart"]');
      wrap.innerHTML = tmpl ? tmpl.innerHTML : `<button type="button" class="btn comparison-table__atc-btn comparison-table__atc-btn--in-cart" disabled>${this.inCartText}</button>`;
    }

    _setATC(wrap) {
      const variantId    = wrap.dataset.variantId || '';
      const productTitle = wrap.dataset.productTitle || '';
      wrap.innerHTML =
        `<form action="/cart/add" method="post" class="comparison-table__atc-form">` +
        `<input type="hidden" name="id" value="${variantId}">` +
        `<input type="hidden" name="quantity" value="1">` +
        `<button type="submit" class="btn comparison-table__atc-btn" aria-label="${this.atcText}: ${productTitle}">${this.atcText}</button>` +
        `</form>`;
    }

    _setSoldOut(wrap) {
      const tmpl = this.querySelector('template[data-tmpl="sold-out"]');
      wrap.innerHTML = tmpl ? tmpl.innerHTML : `<button type="button" class="btn comparison-table__atc-btn comparison-table__atc-btn--sold-out" disabled>${this.soldOutText}</button>`;
    }

    _updateCartCount(count) {
      document.querySelectorAll(
        '.js-cart-count, [data-cart-count], .ajax-cart__trigger-count, .cart__count-bubble span'
      ).forEach(el => { el.textContent = count; });
    }

    async _refreshCartUI() {
      const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json());
      this._updateCartCount(cart.item_count);
      try {
        const configEl = document.getElementById('cart-config');
        const config   = configEl ? JSON.parse(configEl.innerHTML || '{}') : {};

        if (window.Shopify && Shopify.theme && Shopify.theme.ajaxCart) {
          if (Shopify.theme.ajaxCart.showDrawer) Shopify.theme.ajaxCart.showDrawer(config);
          if (Shopify.theme.ajaxCart.showModal)  Shopify.theme.ajaxCart.showModal(config);
          if (Shopify.theme.ajaxCart.updateView) Shopify.theme.ajaxCart.updateView(config, cart);
        } else if (window.WAU) {
          if (WAU.Slideout) WAU.Slideout._openByName('slideout-ajax-cart');
          else if (WAU.Modal) WAU.Modal._openByName('modal-ajax-cart');
        }
      } catch (_) { /* cart UI unavailable */ }
    }
  }

  customElements.define('comparison-table', ComparisonTable);
}
